module.exports = __webpack_public_path__ + "img/logo-footer-01.b1c591eb.jpg";